import { expValEquals } from '@atlassian/jira-feature-experiments';
import { PROJECT_PICKER_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { PROJECT_FIELD_GQL_TYPE } from '../constants.tsx';
import type { jiraProjectFieldFragment as JiraProjectField } from '../fragment/__generated_apollo__/jiraProjectFieldFragment.ts';
import type { TransformedProjectField } from '../types.tsx';
import type { ProjectTransformersMapping } from './types.tsx';

export const transformProjectField = (): ProjectTransformersMapping => ({
	[PROJECT_FIELD_GQL_TYPE]: (field: JiraProjectField): TransformedProjectField | null => {
		if (field.__typename !== PROJECT_FIELD_GQL_TYPE) {
			return null;
		}

		return {
			type: PROJECT_PICKER_CF_TYPE,
			fieldId: field.fieldId,
			name: field.name,
			value: field.project
				? {
						id: field.project.id,
						name: field.project.name ?? '',
						key: field.project.key ?? '',
						avatarUrls: { '48x48': field.project.avatar?.large ?? '' },
						projectId: expValEquals('list_view_conditional_formatting', 'cohort', 'variation')
							? field.project.projectId
							: undefined,
					}
				: null,
		};
	},
});
